import { MDBBtn, MDBIcon } from 'mdb-react-ui-kit'
import React from 'react'

const SocialButtons = () => {
  return (
    <div className="d-flex flex-column align-items-center">
        <div>
            <MDBBtn floating outline href='' className="social-button me-3">
                <MDBIcon fab icon='twitter' size='lg' />
            </MDBBtn>
            <MDBBtn floating outline href='' className="social-button me-3">
                <MDBIcon fab icon='facebook' size='lg' />
            </MDBBtn>
            <MDBBtn floating outline href='' className="social-button me-3">
                <MDBIcon fab icon='instagram' size='lg' />
            </MDBBtn>
        </div>
        <p className="style5 mt-3">© The Perfect Getaway Corp. All rights reserved.</p>
    </div>
  )
}

export default SocialButtons